import { useEffect, useState } from "react";
import { MealPlan } from "../../../utils/api-objects/meal-plan";
import { getMealPlansApi } from "../../../utils/apis/plan-service";
import { useAuth } from "../../../utils/context/AuthContext";

export const useGetMealPlans = (patientId: string | null) => {
    const { auth } = useAuth()
    const idToken = auth.idToken

    const [mealPlans, setMealPlans] = useState<MealPlan[]>();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!patientId || !idToken) return;

        const fetchMealPlans = async () => {
            setIsLoading(true)
            try {
                const plans = await getMealPlansApi(idToken, patientId);
                setMealPlans(plans);
            } catch (error) {
                console.error("Errore nel caricamento dei meal plan:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchMealPlans()
    }, [patientId, idToken])

    return { mealPlans, isLoading }
}